<!--
 * @Description: 流程流转
 * @Author: wangwangwang
 * @Date: 2020-09-05 11:17:49
 * @LastEditors: mw
 * @LastEditTime: 2023-05-23 17:06:36
-->
<template>
  <section>
    <el-dialog v-dialogDrag :visible.sync="approvalVisible" width="65%" :before-close="handleClose">
      <span slot="title">流程流转</span>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width:100%" :data="showApprovalNode" tooltip-effect="dark">
        <el-table-column align="center" label="节点序号" prop="place">
          <template slot-scope="scope">
            <span>{{scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="节点名称" prop="nodeName"></el-table-column>
        <el-table-column align="center" label="处理人" prop="roadwork">
          <template slot-scope="scope">
            <span>{{scope.row.showName || '请选择处理人'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="多人审批类型">
          <template slot-scope="scope">
            <span>{{applyTypeList[scope.row.multiApprovalType]}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.check" class="bottom_text" type="text" @click="hanldeChoise(scope.row,scope.$index)">选择处理人</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" size="medium" @click="handleClose">取 消</el-button>
        <el-button class="bottom_all" size="medium" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
    <personModel :visible='visible' :isPerson="true"  :isFlow="true" :choisedDatas="choisedData" :recentlyUsers="recentlyUsers" @closeModel='closeModel' @getPerson='getPerson' />
  </section>
</template>
<script>
import personModel from '@/components/ChoisePerson/personModel';
import { queryRecentUser,addOrUpdateRecentUser } from "@/api/wise/settlementTask.js";
export default {
  components: {
    personModel,
  },
  props: ['approvalVisible', 'approvalNode'],
  data() {
    return {
      applyTypeList: ['-', '依次审批', '会签', '或签'],
      visible: false,
      choiseIndex: 0,
      choisedData: [],
      showApprovalNode: [],
      isFirstBtn: false,
      userInfo:"",
      recentlyUsers:[],
      recentlyUsersId:"",
    }
  },
  watch: {
    approvalNode(data) {
      this.nodeDataDispose(data)
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleModal', 1);
    },
    handleSure() {
      if(this.recentlyUsers.length>0) {
        addOrUpdateRecentUser({id:this.recentlyUsersId,recentlyUsers:this.recentlyUsers.length>0 ?JSON.stringify(this.recentlyUsers) : ''})
      }
      this.$emit('handleModal', 2, this.isFirstBtn);
    },
    hanldeChoise(data, index) {
      console.log(data, index);
      this.choiseIndex = index;
      this.visible = true;
      this.choisedData = data.personList;
    },
    closeModel() {
      this.visible = false;
    },
    getPerson(data) {
      this.visible = false;
      if(this.isFirstBtn) {
        this.$emit('sendApprovePerson', data, this.choiseIndex);
      }else{
        this.$emit('sendApprovePerson', data, this.choiseIndex + 1);
      }

      console.log(data)
// 合并两个数组
const combinedArray = [...data, ...this.recentlyUsers];

// 去重
const uniqueArray = combinedArray.filter((item, index, self) =>
    index === self.findIndex((t) => t.id === item.id)
);
// 取前10条数据
const result = uniqueArray.slice(0, 10);
this.recentlyUsers = result

    },
    nodeDataDispose(data) {
      if (data.length) {
        const copyData = JSON.parse(JSON.stringify(data)).filter(item => item.nodeType != 1 && item.nodeType != 2);
        // copyData.pop();
        // copyData.shift();
        this.showApprovalNode = copyData.map(res => {
          return { ...res, check: res.approvalUserTypeId == 6 || res.approvalUserTypeId == 7 || typeof res.showName == 'undefined' ? true : false }
        });
        if(data.isFirstBtn) this.isFirstBtn = data.isFirstBtn;
      }
    },
  },
 async mounted() {
    queryRecentUser().then(res => {
      if(res.code == 1001) {
        if(res.data?.recentlyUsers) {
          this.recentlyUsers = JSON.parse(res.data.recentlyUsers) 
          this.recentlyUsersId = res.data.id
          console.log(this.recentlyUsers)
        }
        
      }
    })
    this.nodeDataDispose(this.approvalNode)
  },
}
</script>
<style scoped>
</style>
